export enum AutobuildTagTypes {
  Accident = 'Accident',
  Contribution = 'Contribution',
  CriticalIllness = 'Critical Illness',
  Dental = 'Dental',
  Files = 'Files',
  General = 'General',
  Hospital = 'Hospital',
  Medical = 'Medical',
  Vision = 'Vision',
}

export interface IAutobuildTagType {
  key: AutobuildTagTypes;
  value: string;
}
